@if (app != null) {
  <div>
    <div>
      @switch (box) {
        @case (app.listId.thread.comments) {
          <div class="mb-2">
            <div class="card my-3">
              <app-post></app-post>
              <!-- stream frame -->
              @if (app.post.posts.length > 0 && app.post.sectionType === 'stream') {
                <div
                  class="post-card"
                  >
                  @for (post of app.post.cleanPosts; track post; let i = $index) {
                    <div>
                      <app-post-item [post]="post"></app-post-item>
                    </div>
                  }
                </div>
              }
              <!-- solutions frame -->
              @if (
                app.post.numberOfSolutions > 0 &&
                app.post.sectionType === 'solution'
                ) {
                <div
                  class="post-card"
                  >
                  @for (solution of app.post.solutions; track solution; let i = $index) {
                    <div>
                      <app-post-item [post]="solution"></app-post-item>
                    </div>
                  }
                </div>
              }
              <!-- comments frame -->
              @if (
                app.post.numberOfComments > 0 && app.post.sectionType === 'comment'
                ) {
                <div
                  class="post-card"
                  >
                  @for (comment of app.post.comments; track comment; let i = $index) {
                    <div>
                      <app-post-item [post]="comment"></app-post-item>
                    </div>
                  }
                </div>
              }
              <!-- tasks frame -->
              @if (app.post.numberOfTasks > 0 && app.post.sectionType === 'task') {
                <div
                  class="post-card"
                  >
                  <div>
                    <app-task-items></app-task-items>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @case (app.listId.thread.files) {
          <div class="border-top">
            @if (!app.thread.isNew && app.unlockedId == null) {
              <app-frame
                [title]="app.text.thread.files"
                [showHeader]="showHeader"
                >
                <div class="controls p-1">
                  @if (app.thread.hasPermissionToEdit) {
                    <app-attachments-controls
                      [id]="app.thread.thread['thread._id']"
                      type="thread"
                    ></app-attachments-controls>
                  }
                </div>
                @if (app.permission.attachments.seeAttachments) {
                  <div>
                    <app-attachments
                      [id]="app.thread.thread['thread._id']"
                      type="thread"
                      [editPermission]="app.thread.hasPermissionToEdit"
                      [files]="app.thread.thread['thread._attachments']"
                      [filesDetails]="app.thread.thread['thread.attachmentHistory']"
                    ></app-attachments>
                  </div>
                }
              </app-frame>
            }
          </div>
        }
        <!-- cam be remove after moving fields to modal/ impacts.html is not used -->
        @case (app.listId.thread.impacts) {
          <div class="border-top">
            <app-frame [title]="app.text.impact.impacts" [showHeader]="showHeader">
              <app-impacts></app-impacts>
            </app-frame>
          </div>
        }
        @case (app.listId.thread.trainseries) {
          <div class="border-top">
            @if (app.unlockedId == null) {
              <app-frame
                [title]="app.text.train.trains"
                [showHeader]="showHeader"
                >
                <app-trainseries></app-trainseries>
              </app-frame>
            }
          </div>
        }
        @case (app.listId.thread.internalItems) {
          <div class="border-top">
            @if (app.unlockedId == null) {
              <app-frame
                [title]="app.text.thread.internalItems"
                [showHeader]="showHeader"
                >
                <app-internal-items></app-internal-items>
              </app-frame>
            }
          </div>
        }
        @case (app.listId.thread.history) {
          <div class="card">
            <app-history></app-history>
          </div>
        }
        @case (app.listId.part.history) {
          <div class="card">
            <app-history></app-history>
          </div>
        }
        @case ('rm-messages') {
          <div class="notes-card my-3">
            <div class="notes-card__header">
              <div class="notes-card__title-group">
                <span class="notes-card__title">{{ app.text.message.note }}</span>
                <span class="notes-card__count">{{ app.message.messages.length }}</span>
              </div>
              @if (
                app.unlockedId == null ||
                app.unlockedId == app.manufacturer.id ||
                app.unlockedId == app.part.id
                ) {
                <app-message
                ></app-message>
              }
            </div>
            <div class="message-card">
              @for (message of app.message.messages; track message; let i = $index) {
                <div>
                  <app-message-item [message]="message"></app-message-item>
                </div>
              }
            </div>
          </div>
        }
        @case (app.listId.thread.description) {
          <div class="border-top">
            <app-frame [showHeader]="showHeader">
              <div class="m-1 px-3 py-2">
                <app-field
                  [model]="app.thread.thread"
                  [field]="app.fieldId.thread.descr"
                  [disabled]="app.isLocked(unlock)"
                  [largeInput]="true"
                  [showLabel]="false"
                ></app-field>
              </div>
            </app-frame>
          </div>
        }
        @case (app.listId.manufacturer.supplyChainSection) {
          <div>
            <app-frame [fieldTableBox]="true">
              <app-modal
                #manufacturingLocationsModal
                [modalTitle]="app.text.manufacturer.manufacturingLocationsModalTitle"
                [showButtons]="false"
                [modalType]="'manufacturingLocations'"
              ></app-modal>
              @for (field of app.getList(box); track field; let index = $index) {
                <app-field
                  [model]="model"
                  [field]="field"
                  [index]="index"
                  [disabled]="app.isLocked(unlock)"
                ></app-field>
                @if (
                  field === app.fieldId.manufacturer.countryOfOrigin &&
                  model[app.fieldId.manufacturer.manufacturingLocations]?.length > 0
                  ) {
                  <app-field
                    [model]="model"
                    [field]="app.fieldId.manufacturer.manufacturingLocations"
                    [index]="index + 1"
                    [disabled]="true"
                    [manufacturingLocationsModal]="manufacturingLocationsModal"
                  ></app-field>
                }
              }
              @if (!app.manufacturer.checkManualOverride) {
                <div
                  class="table-bkgd clear"
                  >
                  <app-supply-chain-table></app-supply-chain-table>
                </div>
              }
            </app-frame>
          </div>
        }
        @case (app.listId.part.stocksSection) {
          <div>
            <app-section-category
              [categories]="app.list.part.sectionCategory"
              [categoryTitle]="app.list.part.sectionCategory"
              [model]="app.part.part"
            ></app-section-category>
          </div>
        }
        @default {
          <app-frame
            [title]="app.getText(box)"
            [showHeader]="showHeader"
            >
            @if (box != null) {
              <div>
                @for (field of app.getList(box); track field; let index = $index) {
                  <app-field
                    [model]="model"
                    [field]="field"
                    [index]="index"
                    [publicFieldName]="publicFieldName"
                    [disabled]="app.isLocked(unlock)"
                  ></app-field>
                }
              </div>
            }
          </app-frame>
        }
      }
    </div>
  </div>
}
